@use '../@shared/global' as *;
@use '../@shared/alert.mixin' as *;
@use '../@shared/form-field.mixin' as *;
@use '../@shared/input-container.mixin' as *;
@use '../@shared/mixins' as *;
@use '../host-display-block' as *;

@layer kol-component {
	@include kol-alert;
	@include kol-form-field;
	@include kol-input-container;

	.kol-textarea {
		width: 100%;

		&:focus {
			outline: none;
		}
	}
}
